



















import Vue from 'vue';
import ModalBase from '@/components/util/ModalBaseV3.vue';

export default Vue.extend({
  name: 'ModalInputBase',
  components: { ModalBase},
  props: {
    title: String,
    okButton: String,
    cancelButton: String,
  },
  data() {
    return {};
  },
  methods: {
    onClickOK() {
      this.$emit('ok');
    },
    onClickClose() {
      this.$emit('close');
    },
  },
});
